import { AxiosError } from "axios"
import {
	ErrorMessages,
	ErrorResponseCodes,
	GENERIC_ERROR,
	NoDataMessage,
} from "./AsyncMessageResponseHandler.constants"

type ErrorResponseType = {
	errCode: string
	status: string
}

export const getErrorOrNoData = (error: AxiosError<any> | null) => {
	if (!error) {
		return NoDataMessage
	}

	const errorResponse = getError(error)

	return getErrorMessageByCode(errorResponse)
}

export const getError = ({ response }: AxiosError<any>): ErrorResponseType => {
	if (!response) {
		return GENERIC_ERROR
	}

	const { status, data } = response
	const { errCode } = data

	return { errCode, status: String(status) }
}

export const getErrorMessageByCode = ({ errCode, status }: ErrorResponseType) =>
	ErrorMessages[errCode] ??
	ErrorMessages[status] ??
	ErrorMessages[ErrorResponseCodes.Generic]

export const hasErrorOrNotData = (isError: boolean, hasData: boolean) =>
	isError || !hasData
